import { EnvType } from "./common";

export const BASE_URL = `${import.meta.env.VITE_APP_API_URL}/admin` || "http://localhost:5000/api/admin";

export const URL = {
  ADMINS_COUNT: "/admins/count",
  CONTROLLERS_COUNT: "/controllers/count",
  CHECK_AUTH_FLOW: "/auth/check-flow",
  CHECK_MFA_CODE: "/auth/check-mfa-code",
  CURRENT_ADMIN: "/admins/me",
  LOCATIONS_LIST: "/locations?limit=0&page=0",
  ORGANIZATIONS_COUNT: "/organizations/count",
  ORGANIZATIONS_LIST: "/organizations?limit=0&page=0",
  REDEEM_INVITATION_CODE: "auth/invitation-code",
  REFRESH_TOKEN_URL: "/auth/refresh",
  SET_PASSWORD: "/auth/set-password",
  SIGN_IN: "/auth/sign-in",
  SIGN_OUT: "/auth/sign-out",
  USERS_COUNT: "/users/count",
  USERS_LIST: "/users?limit=0&page=0",
  USERS_UNASSIGNED: "/users/unassigned",
  VERIFY_MFA_TOKEN: "/auth/verify-mfa-token",
};
